import { render, staticRenderFns } from "./AlternativeComponent.vue?vue&type=template&id=a7b2c9c6&scoped=true"
import script from "./AlternativeComponent.vue?vue&type=script&lang=js"
export * from "./AlternativeComponent.vue?vue&type=script&lang=js"
import style0 from "./AlternativeComponent.vue?vue&type=style&index=0&id=a7b2c9c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7b2c9c6",
  null
  
)

export default component.exports